import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const textConditionList = [
  'Begin with',
  'Contains',
  'Doesn\'t contain',
  'Ends with',
  'Equals',
  'Doesn\'t equal',
];

let typingTimer;
const doneTypingInterval = 1000;

const TagFilterHeaderCell = (props) => {
  const [data, setData] = useState(props.value);
  const [conditionIndex, setConditionIndex] = useState(props.conditionIndex);
  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  const filterString = useMemo(() => {
    let filterStringTemp = '';
    for (let i = 0; i < data.length; i++) {
      filterStringTemp += data[i];
    }
    return filterStringTemp;
  }, [data]);

  const wrapperRef = useRef(null);
  const input = useRef(null);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsOpenDropDown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const doneTyping = () => {
    const { setFilter } = props;
    setData([input.current.value]);
    setFilter({ data: [input.current.value], conditionIndex, isOpenDropDown });
  };

  const onKeyUpHandler = () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  };

  const onKeyDownHandler = () => {
    clearTimeout(typingTimer);
  };

  const onChangeHander = () => {
    setData([input.current.value]);
  };

  const handleCondition = (index) => {
    const { setFilter } = props;
    setConditionIndex(index);
    setFilter({ conditionIndex: index, data, isOpenDropDown });
  };

  const toggleDropDown = () => {
    setIsOpenDropDown(!isOpenDropDown);
  };

  return (
    <th className="header-cell">
      <div className="header-cell-container has-filter" ref={wrapperRef}>
        <input
          type="text"
          className="form-control"
          placeholder=""
          value={filterString}
          ref={input}
          onChange={() => onChangeHander()}
          onKeyUp={() => onKeyUpHandler()}
          onKeyDown={() => onKeyDownHandler()}
        />
        <button className="btn btn-xs btn-default btn-key dropdown-toggle" data-toggle="dropdown" onClick={toggleDropDown}>
          <i className="glyphicon glyphicon-filter" />
        </button>
        <ul className={classNames('dropdown-menu', 'first', isOpenDropDown && 'open')} role="menu">
          {
            textConditionList.map((item, index) => (
              <li key={`fromfilter-condition-${index.toString()}`}>
                <a href={window.location.href} onClick={() => handleCondition(index)} className={classNames({ 'active-dropdown': index === conditionIndex })}>{item}</a>
              </li>
            ))
          }
        </ul>
      </div>
    </th>
  );
};

TagFilterHeaderCell.propTypes = {
  setFilter: PropTypes.func,
  value: PropTypes.string,
  conditionIndex: PropTypes.number,
};

TagFilterHeaderCell.defaultProps = {
  setFilter: () => {},
  value: '',
  conditionIndex: 1,
};

export default TagFilterHeaderCell;



// WEBPACK FOOTER //
// ./src/components/Tables/TagFilterHeaderCell.js